module.exports = __webpack_public_path__ + "img/logo-cgt-v2.ade1b2b.png";